import { apiExpress } from 'lib/config';
import { useQueryFetch } from './useQueryFetch';

export interface AuthDataBase {
  username: string;
  password: string;
}

export interface AuthData extends AuthDataBase {
  remember?: boolean;
  jwt?: string;
  redirect?: string;
}

interface AuthResponse {
  tokenType: string;
  accessToken: string;
  refreshToken: string;
}

export const useAuth = () => {
  const { data, error, loading, fetchData } = useQueryFetch({
    pathname: '',
  });
  const fetch = (data: AuthData) => {
    const url = data.redirect ? encodeURIComponent(data.redirect) : '';
    const { password, username } = data;
    fetchData({
      method: 'post',
      url: `auth/` + url,
      baseURL: apiExpress,
      data: { password, username },
    });
  };

  const loginData: AuthResponse = data;

  return { loginData, loading, error, fetch };
};
